import tpv from './base';
import { apiGetter } from '@synergycms_core/utils/api';
import { Map } from 'immutable';

export const url = {
  stage: {
    redsysUrl: 'https://sis-t.redsys.es:25443/sis/realizarPago'
  },
  prod: {
    redsysUrl: 'https://sis.redsys.es/sis/realizarPago'
  }
};
export default class REDSYS extends tpv {
  environment = 'stage';

  /**
   *
   * @param environment {string}
   * @param reservation {Map}
   * @param hotel {Map}
   * @param tpvPaymentStatus {string}
   * @param setReservationPayed {function}
   * @param showConfirmation {function}
   * @param showErrorNotification {function}
   */
  constructor(
    environment,
    reservation,
    hotel,
    tpvPaymentStatus,
    setReservationPayed,
    showConfirmation,
    showErrorNotification
  ) {
    super();
    this.environment = environment;
    this.api = apiGetter(url[this.environment].redsysUrl, 'form');

    if (
      tpvPaymentStatus === 'REDSYS:OK' &&
      reservation.get('status') === 'confirmed' &&
      reservation.getIn(['payment', 'payform_code']) === 'op'
    ) {
      showConfirmation(reservation, hotel);
    } else if (tpvPaymentStatus === 'REDSYS:ERROR') {
      if(reservation.getIn(['payment', 'payform_code']) === 'op' && reservation.getIn(['payment', 'bizum_charge'],false) ){
        showErrorNotification('ha ocurrido un error con el proceso de pago online con Bizum, por favor, vuelva a intentarlo');
      } else {
        showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
      }
    }
  }

  /**
   *
   * @param hotel {Map}
   * @param reservation {Map}
   * @param countryCode {string}
   * @param langCode  {string}
   * @param formId {string}
   * @param showErrorNotification {function}
   */
  initialize = (
    hotel,
    reservation,
    countryCode,
    langCode,
    formId,
    showErrorNotification,
    selectedPayform
  ) => {
    if (
      reservation.get('status') === 'confirmed' &&
      reservation.getIn(['payment', 'payform_code']) === 'op' &&
      reservation.getIn(['payment', 'state']) === 'pending'
    ) {
      if(reservation.getIn(['payment', 'payform_code']) === 'op' && reservation.getIn(['payment', 'bizum_charge'],false) ){
        showErrorNotification('ha ocurrido un error con el proceso de pago online con Bizum, por favor, vuelva a intentarlo');
      } else {
        showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
      }
    }

    const amountPromoPaid = reservation.getIn(['payment', 'amount_promo_paid'], 0);
    const amountToPay = reservation.get('total_price_tax') - amountPromoPaid;

    return this.getRedsysParams(
      hotel.get('code'),
      amountToPay,
      reservation.get('tracking_id'),
      hotel.get('id'),
      document.URL,
      0,
      'reservation',
      null,
      selectedPayform
    ).then(result => {
      this.queryObj = result;
    });

  };

  /**
   *
   * @param hotel {Map}
   * @param trackingID {Number}
   * @param amountToPay {Number}
   * @param resType {string}
   * @param confirmationUrl {string}
   */
  initializeGeneric = (
    hotel,
    trackingID,
    amountToPay,
    resType,
    confirmationUrl
  ) => {

    return this.getRedsysParams(
      hotel.get('code', false),
      amountToPay,
      trackingID,
      hotel.get('id'),
      document.URL,
      0,
      resType,
      confirmationUrl
    ).then(result => {
      return this.queryObj = result;
    });

  };


  /**
   *
   * @param hotelCode {string}
   * @param price {Number}
   * @param trackingId {Number}
   * @param hotelId {Number}
   * @param redirectUrl {string}
   * @param type {Number}
   * @param resType {string}
   * @param confirmationUrl {string}
   * @returns {Promise}
   */
  getRedsysParams = (hotelCode, price, trackingId, hotelId, redirectUrl, type, resType, confirmationUrl, bizum = false) => {
    const domain = process.env.NODE_ENV != 'production' ? 'https://syn2pre.booking-channel.com' : 'https://synergy.booking-channel.com';
    const url = domain + '/api/hotels/' + hotelId + '/redsys_payments';
    const data = {
      type: type,
      res_type: resType,
      amount: price,
      location: redirectUrl
    };

    if (resType === 'gift_voucher') {
      data.id = trackingId;
      data.confirmation_url = confirmationUrl;
    } else {
      if(bizum && bizum === 'bizum') {
        data.bizum_charge = 1;
      }
      data.id = hotelCode + '-' + trackingId;
    }

    return this.query(url, 'POST', data);
  };


  validatePayment = () => {
    this.api.post(this.queryObj);
  };


}
